<template>
    <div class="masterdata-right">
      <div class="masterdata-table">
        <table class="table-db table-db-hover">
          <thead>
          <tr>
            <th @click="sort('nomor')">Nomor <i :class="currentSort === 'nomor' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('jenis')">Jenis <i :class="currentSort === 'jenis' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            
            <th @click="sort('bidang')">Bidang <i :class="currentSort === 'bidang' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('sub_bidang')">Sub Bidang <i :class="currentSort === 'sub_bidang' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('jenis_pekerjaan')">Jenis Pekerjaan <i :class="currentSort === 'jenis_pekerjaan' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>

            <th @click="sort('kbli')">KBLI <i :class="currentSort === 'kbli' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>

            <th @click="sort('kbug')">KBUG <i :class="currentSort === 'kbug' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>

            <th @click="sort('nilai_risiko')">Nilai Risiko <i :class="currentSort === 'nilai_risiko' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>

            <th @click="sort('tingkat_risiko')">Tingkat Risiko <i :class="currentSort === 'tingkat_risiko' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>

            <th @click="sort('last_modified_date')">Last Modified Date <i :class="currentSort === 'last_modified_date' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('last_modified_by')">Last Modified By <i :class="currentSort === 'last_modified_by' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('status')">Status <i :class="currentSort === 'status' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
            <th @click="sort('catatan')">Catatan <i :class="currentSort === 'catatan' ? currentSortDir === 'desc' ? 'fas fa-long-arrow-alt-down' : 'fas fa-long-arrow-alt-up' : 'fas fa-arrows-alt-v'"></i></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td>{{list.nomor}}</td>
            <td>{{ list.jenis }}</td>
            <td>
              {{list.bidang}}
            </td>
            <td>
              {{list.sub_bidang}}
            </td>
            <td>{{list.jenis_pekerjaan}}</td>
            <td>{{list.kbli}}</td>
            <td>{{list.kbug}}</td>
            <td>{{list.nilai_risiko}}</td>
            <td>{{list.tingkat_risiko}}</td>
            <td>{{list.last_modified_date}}</td>
            <td>{{list.last_modified_by}}</td>
            <td :style="{color: list.status === 'Active' ? 'green' : 'red'}">{{ list.status }}</td>
            <td>{{list.catatan }}</td>
          </tr>
        </tbody>
        </table>
      </div>
    </div>
    </template>
    
    <script>
      export default {
        props:{
          'isEdit' : Boolean,
        },
        data() {
          return {
            currentSort: '',
            currentSortDir: '',
            arrow : false,
            data: [
    {
        "nomor": "1",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pengupasan, Pemuatan, dan Pemindahan Tanah / Batuan Penutup",
        "jenis_pekerjaan": "Pengangkutan Batubara atau Lapisan Penutup",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "11,1",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "2",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pengupasan, Pemuatan, dan Pemindahan Tanah / Batuan Penutup",
        "jenis_pekerjaan": "Layanan Monitoring Kayu",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "5,6",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "3",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pemberaian / Pembongkaran Tanah / Bantuan Penutup",
        "jenis_pekerjaan": "Layanan Bahan Peledak & Peledakan",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "6,9",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "4",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pemberaian/Pembongkaran Tanah / Bantuan Penutup",
        "jenis_pekerjaan": "Pengelolaan Bahan peledak",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "9,7",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "5",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pengangkutan Tanah, Penutup, Batubara, Bijih Mineral",
        "jenis_pekerjaan": "Pembersihan Lahan - Layanan dengan menggunakan mesin",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "5,8",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "6",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pengangkutan Tanah, Penutup, Batubara, Bijih Mineral",
        "jenis_pekerjaan": "Pembersihan Lahan - Layanan Manual",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "2,6",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "7",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pemakaian alat berat untuk kegiatan lainnya",
        "jenis_pekerjaan": "Miscellaneous Supply & Operations (Penyediaan & Pengoperasian Lain-lain)",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "8,6",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "8",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pemakaian alat berat untuk kegiatan lainnya",
        "jenis_pekerjaan": "Truk Ringan - Penyediaan & Pengoperasian",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "8,4",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "9",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pemakaian alat berat untuk kegiatan lainnya",
        "jenis_pekerjaan": "Layanan HDPE",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "5,6",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "10",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Superintending",
        "jenis_pekerjaan": "Layanan Superintending Batubara",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "5,1",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "11",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Superintending",
        "jenis_pekerjaan": "Layanan Survei & Analisis Batubara",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "3,5",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "12",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Superintending",
        "jenis_pekerjaan": "Layanan Laboratorium Batubara",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "4,1",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "13",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Pemeliharaan prasarana dan fasilitas pertambangan",
        "jenis_pekerjaan": "Perintisan rumput",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "4,4",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    },
    {
        "nomor": "14",
        "jenis": "Konsultasi dan/atau Perencanaan",
        "bidang": "Penambangan",
        "sub_bidang": "Penggalian Batubara (coal getting",
        "jenis_pekerjaan": "Layanan Penambangan",
        "kbli": "Pertambangan",
        "kbug": "-",
        "nilai_risiko": "20,7",
        "tingkat_risiko": "Kritis",
        "last_modified_date": "-",
        "last_modified_by": "System",
        "status": "Active",
        "catatan": "-"
    }
]
          }
        },
    
      methods:{
        sort(s) {
        if(s === this.currentSort) {
          this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
        }
        this.currentSort = s;
      },
    },
    
    computed:{
      sortedData() {
        return this.data.sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      }
    },
    
      }
    </script>